import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

const getOptions = (
  xLabel,
  yLabel,
  minData = 0,
  maxData = 100,
  stepSize = 10,
) => ({
  responsive: true,
  legend: {
    display: false,
  },
  plugins: {
    datalabels: {
      anchor: "center",
      align: "center",
      color: "white",
      font: {
        weight: "bold",
      },
      formatter: (value) => value,
    },
  },
  scales: {
    yAxes: [
      {
        ticks: {
          min: minData,
          max: maxData,
          stepSize: stepSize,
          beginAtZero: true,
        },
        scaleLabel: {
          display: true,
          labelString: yLabel,
        },
      },
    ],
    xAxes: [
      {
        gridLines: {
          color: "#0000",
        },
        scaleLabel: {
          display: true,
          labelString: xLabel,
        },
      },
    ],
  },
});

const BarChartReact = ({ range, chartConfig }) => {
  const { meta, ranges } = chartConfig;
  const currentRange = ranges[range];

  const data = {
    labels: currentRange.labels,
    datasets: [
      {
        label: meta.datasetLabel,
        data: currentRange.values,
        backgroundColor: "rgba(0,0,0,.9)",
        borderColor: "rgba(0,0,0,1)",
        borderWidth: 1,
      },
    ],
  };

  return (
    <Bar
      key={range} // 🔥 forces re-render on range change
      data={data}
      options={getOptions(
        meta.xLabel,
        meta.yLabel,
        meta.minData,
        meta.maxData,
        meta.stepSize,
      )}
      plugins={[ChartDataLabels]}
    />
  );
};

export default BarChartReact;
